<script setup lang="ts">
// interface
interface Props {
  isVisible?: boolean;
}

interface Emits {
  (e: "closeDialog"): void;
  (e: "verifiedByUser", val: boolean): void;
}

// props
const props = defineProps<Props>();

// emit
const emit = defineEmits<Emits>();
</script>

<template>
  <VDialog :model-value="props?.isVisible" persistent max-width="490">
    <VCard height="auto" flat>
      <div
        class="d-flex align-center justify-space-between bg-dialogHeaderColor"
      >
        <!-- 👉 Header -->
        <VCardTitle> Left handed warning! </VCardTitle>
        <VBtn
          icon="mdi-close"
          size="large"
          variant="text"
          class="rounded-0"
          color=""
          @click="emit('closeDialog')"
        ></VBtn>
      </div>

      <VCardText>
        <div class="booking_stepper__agreement-message">
          <div>
            You are trying to book a bay that cannot be played left handed with
            at least one player that's left handed
          </div>
          <div class="mt-2">
            If no left handed capable bay is available you can call, and we can
            try and accommodate you, or pick another time that a left hand
            capable bay is available
          </div>
          <div class="mt-2">Are you sure you want to confirm the booking?</div>
        </div>
      </VCardText>
      <VCardActions class="d-flex justify-end pb-3">
        <VBtn color="error" variant="flat" @click="emit('closeDialog')"
          >No</VBtn
        >
        <VBtn
          color="success"
          variant="flat"
          text
          @click="emit('verifiedByUser', true)"
          >Yes</VBtn
        >
      </VCardActions>
    </VCard>
  </VDialog>
</template>
